import moment from 'moment'
import {
  ACCEPTABLE_FILE_MAX_CONTENT_LENGTH,
  PASSWORD_REGEX,
  PHONE_NUMBER_REGEX,
  REQUIRED_TEXT,
} from 'Constants'
import { string } from 'yup'

export const isChecked = (value) => (value === true ? undefined : REQUIRED_TEXT)

export const isAuthTokenValid = (expirationDate) => {
  return moment.utc(expirationDate).diff(moment.utc()) > 0
}

export const uploadFileContentLength =
  (accepted = true) =>
  ({ size, type }) => {
    const isValidSize =
      ACCEPTABLE_FILE_MAX_CONTENT_LENGTH[type] &&
      ACCEPTABLE_FILE_MAX_CONTENT_LENGTH[type].MIN <= size &&
      ACCEPTABLE_FILE_MAX_CONTENT_LENGTH[type].MAX >= size

    return accepted && isValidSize
  }

export const validateConfirmPassword = (passwordFieldName) => (value, allValues) => {
  const validateMatchesMessage = 'Passwords must match'
  try {
    const passwordValue = allValues[passwordFieldName]
    string(validateMatchesMessage)
      .oneOf([passwordValue], validateMatchesMessage)
      .required(validateMatchesMessage)
      .validateSync(value)
  } catch ({ errors }) {
    return errors[0]
  }
}

export const validateEmail = (value) => {
  const validationMessage = 'Invalid Email'
  try {
    string(validationMessage)
      .email(validationMessage)
      .required(validationMessage)
      .validateSync(value)
  } catch ({ errors }) {
    return errors[0]
  }
}

export const validatePassword = (value) => {
  const validateRequiredMesssage = 'Required'
  const validateValidMessage = 'Password does not meet requirements'

  try {
    string(validateRequiredMesssage)
      .required(validateRequiredMesssage)
      .matches(PASSWORD_REGEX, { message: validateValidMessage })
      .validateSync(value)
  } catch ({ errors }) {
    return errors[0]
  }
}

export const validatePhoneNumber = (value) => {
  const validationMessage = 'Invalid phone number'
  let modifiedValue = value?.toString()
  if (modifiedValue) {
    /* eslint-disable */
    modifiedValue = (modifiedValue || '')?.replace(/\ /g, '')
  }
  try {
    string(validationMessage)
      .required(validationMessage)
      .matches(PHONE_NUMBER_REGEX, { message: validationMessage })
      //.test('len', 'Max 10 numbers', (modifiedValue) => modifiedValue.toString().length > 10)
      //.max(10, 'Max 10 numbers')
      .validateSync(modifiedValue)
  } catch ({ errors }) {
    return errors[0]
  }
}

export const validatePromoCode = (value) => {
  const validationMessage = 'Promo code required, please contact us at sales@itemizecorp.com.'
  const stringValue = value ?? ''
  try {
    string(validationMessage).trim().required(validationMessage).validateSync(stringValue)
  } catch ({ errors }) {
    return errors[0]
  }
}

export const validateRequired = (value) => {
  const validationMessage = 'Required'
  const stringValue = value ?? ''
  try {
    string(validationMessage).trim().required(validationMessage).validateSync(stringValue)
  } catch ({ errors }) {
    return errors[0]
  }
}

export const validateRequiredSelect = (option) => {
  return validateRequired(option?.toString())
}
